import { render, staticRenderFns } from "./AuthApp.vue?vue&type=template&id=660d5e2b"
import script from "./AuthApp.vue?vue&type=script&lang=js"
export * from "./AuthApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports